import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft, BellRing, Cookie, FileText, Mail, Scale, Shield } from "lucide-react";
import { clearCookieConsent, getCookieConsent } from "@/lib/cookieConsent";
import { isNativeApp } from "@/lib/runtime";
import "@/styles/native-auth-v3.css";



// KOMIHÅG ATT UPPDATERA LEGAL_LAST_UPDATED NÄR DENNA SIDA ÄNDRAS!
const LEGAL_LAST_UPDATED = "25 augusti 2026";

function Section({ title, children }) {
  return (
    <section className="native-v3-legal-section space-y-2">
      <h3 className="text-base font-semibold text-foreground">{title}</h3>
      <div className="space-y-2 text-sm leading-relaxed text-muted-foreground">{children}</div>
    </section>
  );
}

function IntroNotice({ icon: Icon, children }) {
  return (
    <div className="native-v3-legal-notice flex items-start gap-3 rounded-xl border border-border/60 bg-muted/30 p-4">
      <Icon className="mt-0.5 h-5 w-5 shrink-0 opacity-70" />
      <div className="space-y-1 text-sm leading-relaxed text-muted-foreground">{children}</div>
    </div>
  );
}

function StorageTable() {
  return (
    <div className="native-v3-legal-storage overflow-x-auto rounded-xl border border-border/60">
      <table className="w-full min-w-[680px] text-sm">
        <thead className="bg-muted/40 text-left text-foreground">
          <tr>
            <th className="px-4 py-3 font-medium">Namn</th>
            <th className="px-4 py-3 font-medium">Typ</th>
            <th className="px-4 py-3 font-medium">Syfte</th>
            <th className="px-4 py-3 font-medium">Lagringstid</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-border/60 text-muted-foreground">
          <tr>
            <td className="px-4 py-3 font-mono text-xs">speedway_token</td>
            <td className="px-4 py-3">Local storage</td>
            <td className="px-4 py-3">Håller användaren inloggad i appen.</td>
            <td className="px-4 py-3">Tills användaren loggar ut eller lagringen rensas.</td>
          </tr>
          <tr>
            <td className="px-4 py-3 font-mono text-xs">speedway_user</td>
            <td className="px-4 py-3">Local storage</td>
            <td className="px-4 py-3">Sparar grundläggande kontoinformation för appens gränssnitt.</td>
            <td className="px-4 py-3">Tills användaren loggar ut eller lagringen rensas.</td>
          </tr>
          <tr>
            <td className="px-4 py-3 font-mono text-xs">lapstr:privacy-consent:v2</td>
            <td className="px-4 py-3">Local storage</td>
            <td className="px-4 py-3">Sparar ditt val för frivillig användningsstatistik.</td>
            <td className="px-4 py-3">Tills valet ändras eller lagringen rensas.</td>
          </tr>
          <tr>
            <td className="px-4 py-3 font-mono text-xs">_ga och _ga_*</td>
            <td className="px-4 py-3">Webbcookies</td>
            <td className="px-4 py-3">
              Används för att skilja webbläsare och sessioner åt inom ramen för frivillig
              användningsstatistik.
            </td>
            <td className="px-4 py-3">Upp till 2 år eller tills samtycket återkallas och cookies rensas.</td>
          </tr>
          <tr>
            <td className="px-4 py-3 font-mono text-xs">Analysidentifierare (mobilapp)</td>
            <td className="px-4 py-3">Appidentifierare</td>
            <td className="px-4 py-3">
              Används för frivillig användningsstatistik i mobilappen.
            </td>
            <td className="px-4 py-3">Tills samtycket återkallas, appdata återställs eller appen avinstalleras.</td>
          </tr>
          <tr>
            <td className="px-4 py-3 font-mono text-xs">sid</td>
            <td className="px-4 py-3">HttpOnly-cookie</td>
            <td className="px-4 py-3">Används efter samtycke för att begränsa visningsfrekvens och mäta annonser.</td>
            <td className="px-4 py-3">180 dagar.</td>
          </tr>
          <tr>
            <td className="px-4 py-3 font-mono text-xs">lapstr_pwa_installed</td>
            <td className="px-4 py-3">Cookie</td>
            <td className="px-4 py-3">Markerar att användaren redan installerat PWA-versionen.</td>
            <td className="px-4 py-3">365 dagar.</td>
          </tr>
          <tr>
            <td className="px-4 py-3 font-mono text-xs">lapstr:pwa-installed-at, lapstr:pwa-install-dismissed-at</td>
            <td className="px-4 py-3">Local storage</td>
            <td className="px-4 py-3">Används för att styra när PWA-installationsprompten ska visas igen.</td>
            <td className="px-4 py-3">Tills värdet skrivs över eller lagringen rensas.</td>
          </tr>
          <tr>
            <td className="px-4 py-3 font-mono text-xs">lapstr:pwa-notification-onboarding och relaterade nycklar</td>
            <td className="px-4 py-3">Local storage</td>
            <td className="px-4 py-3">Styr om och när onboarding för pushnotiser ska visas i den installerade appen.</td>
            <td className="px-4 py-3">Tills värdet skrivs över eller lagringen rensas.</td>
          </tr>
          <tr>
            <td className="px-4 py-3 font-mono text-xs">lapstr:push-installation-id</td>
            <td className="px-4 py-3">Local storage</td>
            <td className="px-4 py-3">Identifierar webbläsarens eller enhetens pushinstallation för notiser.</td>
            <td className="px-4 py-3">Tills värdet skrivs över eller lagringen rensas.</td>
          </tr>
          <tr>
            <td className="px-4 py-3 font-mono text-xs">speedway:tutorial:*</td>
            <td className="px-4 py-3">Local/session storage</td>
            <td className="px-4 py-3">Sparar introguide, sidoguider och temporär tutorialstatus per användare.</td>
            <td className="px-4 py-3">Tills värdet skrivs över eller lagringen rensas.</td>
          </tr>
          <tr>
            <td className="px-4 py-3 font-mono text-xs">Sessions- och UI-nycklar</td>
            <td className="px-4 py-3">Session/local storage</td>
            <td className="px-4 py-3">Används för tillfällig UI-status, scrollposition, meddelanden och återupptagning av vissa flöden.</td>
            <td className="px-4 py-3">Normalt tills fliken stängs eller tills värdet skrivs över/rensas.</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export default function LegalPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const native = isNativeApp();
  const publicRoute = location.pathname === "/legal";
  const consent = getCookieConsent();
  const tabFromHash = (location.hash || "").replace("#", "");
  const normalizedTab = tabFromHash === "beta" ? "contact" : tabFromHash;
  const activeTab = ["privacy", "terms", "notifications", "cookies", "contact"].includes(normalizedTab)
    ? normalizedTab
    : "privacy";

  return (
    <div className={native ? "native-v3-legal-page" : "relative"}>
      {native && publicRoute ? (
        <header className="native-v3-legal-public-header">
          <button type="button" onClick={() => navigate("/auth")} aria-label="Tillbaka till inloggningen">
            <ArrowLeft aria-hidden="true" />
            <span>Tillbaka</span>
          </button>
          <h1>Villkor & integritet</h1>
          <span aria-hidden="true" />
        </header>
      ) : null}

      <Card className={native ? "native-v3-legal-card" : "rounded-2xl"}>
        <CardHeader className={native ? "native-v3-legal-intro" : "space-y-3"}>
          <div className="flex flex-wrap items-center gap-2">
            <CardTitle className="flex items-center gap-2">
              <FileText className="h-5 w-5 shrink-0 opacity-70" />
              <span>Villkor & integritet</span>
            </CardTitle>
          </div>
          <p className="text-sm text-muted-foreground">
            Här hittar du information om hur Lapstr behandlar personuppgifter, hur tjänsten får
            användas, hur notiser och lagring fungerar samt hur du kontaktar oss.
          </p>
          <p className="text-xs text-muted-foreground">Senast uppdaterad: {LEGAL_LAST_UPDATED}</p>
        </CardHeader>

        <CardContent className={native ? "native-v3-legal-content" : "pb-24"}>
          <Tabs
            value={activeTab}
            onValueChange={(next) => navigate({ hash: `#${next}` }, { replace: true })}
            className={native ? "native-v3-legal-tabs" : "w-full"}
          >
            <TabsList className={native ? "native-v3-legal-tab-list" : "mb-4 w-full justify-start overflow-x-auto"}>
              <TabsTrigger value="privacy">Integritet</TabsTrigger>
              <TabsTrigger value="terms">Villkor</TabsTrigger>
              <TabsTrigger value="notifications">Notiser</TabsTrigger>
              <TabsTrigger value="cookies">Cookies</TabsTrigger>
              <TabsTrigger value="contact">Kontakt</TabsTrigger>
            </TabsList>

            <TabsContent value="privacy" className="space-y-5">
              <Section title="Personuppgiftsansvarig">
                <IntroNotice icon={Shield}>
                  <p>
                    MV Kod &amp; Design AB är personuppgiftsansvarig för Lapstr. För
                    integritetsfrågor kontaktar du{" "}
                    <a className="text-primary underline-offset-4 hover:underline" href="mailto:support@lapstr.se">
                      support@lapstr.se
                    </a>
                    . Fullständiga företagsuppgifter finns under Kontakt.
                  </p>
                </IntroNotice>
              </Section>

              <Section title="Vilka uppgifter vi behandlar">
                <ul className="list-disc space-y-1 pl-5">
                  <li>Kontouppgifter som e-postadress, visningsnamn och inloggningsmetod.</li>
                  <li>Säkerhetsuppgifter som aktiva sessioner, enhetsinformation och verifieringsstatus.</li>
                  <li>Data som du själv skapar i tjänsten, till exempel matchprotokoll och inställningar.</li>
                  <li>
                    Offentlig tävlingsinformation, till exempel förares namn, lagtillhörighet,
                    nationalitet och matchresultat från offentliga källor eller administratörer.
                  </li>
                  <li>Pushprenumerationer och notisinställningar om du aktiverar notiser.</li>
                  <li>
                    Appaktivitet och tekniska app- eller enhetsidentifierare om du frivilligt
                    tillåter användningsstatistik.
                  </li>
                  <li>Ditt separata val om frivilliga e-postutskick från Lapstr.</li>
                  <li>
                    Åldersgrupp för att tillämpa rätt skyddsnivå. Födelsedatumet används för
                    beräkningen men sparas inte.
                  </li>
                  <li>Begränsad teknisk driftdata för felsökning, säkerhet och skydd mot missbruk.</li>
                </ul>
              </Section>

              <Section title="Ändamål och rättslig grund">
                <ul className="list-disc space-y-1 pl-5">
                  <li>
                    Konto, inloggning, matchprotokoll, inställningar och begärda notiser behandlas
                    för att fullgöra avtalet med dig och leverera de funktioner du använder.
                  </li>
                  <li>
                    Säkerhetsloggar, sessionshantering, support, felsökning och skydd mot missbruk
                    behandlas med stöd av vårt berättigade intresse av att driva en säker och
                    fungerande tjänst.
                  </li>
                  <li>
                    Offentlig tävlingsinformation behandlas med stöd av vårt berättigade intresse
                    av att tillhandahålla aktuell speedwayinformation och matchfunktioner.
                  </li>
                  <li>
                    Användningsstatistik och frivilliga e-postutskick behandlas endast med ditt
                    separata samtycke. Samtycket kan återkallas när som helst i inställningarna.
                  </li>
                  <li>
                    Uppgifter kan även behandlas när det krävs för att uppfylla en rättslig
                    skyldighet eller för att fastställa, göra gällande eller försvara rättsliga anspråk.
                  </li>
                </ul>
              </Section>

              <Section title="Mottagare av personuppgifter">
                <ul className="list-disc space-y-1 pl-5">
                  <li>Leverantörer av hosting, drift och databaslagring.</li>
                  <li>Leverantörer som skickar konto-, säkerhets- och frivilliga e-postmeddelanden.</li>
                  <li>Leverantörer för extern inloggning och pushnotiser.</li>
                  <li>Leverantörer av användningsstatistik, men endast efter ditt samtycke.</li>
                </ul>
                <p>
                  Dessa mottagare får endast tillgång till de uppgifter som behövs för deras
                  uppdrag. När de behandlar uppgifter för vår räkning regleras behandlingen genom
                  personuppgiftsbiträdesavtal eller motsvarande dataskyddsvillkor.
                </p>
              </Section>

              <Section title="Överföringar utanför EU och EES">
                <p>
                  Vi väljer europeiska driftregioner där det är möjligt. Vissa leverantörer kan
                  ändå behandla eller ge supportåtkomst till uppgifter från länder utanför EU och
                  EES. Sådana överföringar sker endast med stöd av en tillämplig rättslig mekanism,
                  exempelvis
                  EU-kommissionens standardavtalsklausuler eller beslut om adekvat skyddsnivå.
                </p>
              </Section>

              <Section title="Lagringstid">
                <ul className="list-disc space-y-1 pl-5">
                  <li>Kontouppgifter och användarskapade matchprotokoll sparas medan kontot finns eller tills de raderas.</li>
                  <li>Sessioner och pushprenumerationer sparas tills de löper ut, tas bort eller inte längre behövs.</li>
                  <li>Verifierings- och återställningsuppgifter sparas endast under den begränsade giltighetstiden.</li>
                  <li>Samtyckesval och tillhörande historik sparas för att kunna visa hur dina val har hanterats.</li>
                  <li>Tekniska säkerhets- och driftuppgifter sparas endast så länge de behövs för respektive ändamål.</li>
                </ul>
                <p>
                  Vissa uppgifter kan behöva sparas längre om det krävs enligt lag eller för att
                  hantera en säkerhetsincident, tvist eller ett rättsligt anspråk.
                </p>
              </Section>

              <Section title="Dina rättigheter">
                <p>
                  Du kan begära information om vilka uppgifter som behandlas, begära rättelse,
                  radering eller begränsning, invända mot behandling som grundas på berättigat
                  intresse och i vissa fall begära dataportabilitet. Samtycken kan återkallas när
                  som helst utan att det påverkar lagligheten av tidigare behandling. Du kan också
                  ta bort ditt konto direkt i appen.
                </p>
                <p>
                  Om du anser att behandlingen är felaktig kan du lämna klagomål till
                  Integritetsskyddsmyndigheten, IMY, på{" "}
                  <a className="text-primary underline-offset-4 hover:underline" href="https://www.imy.se" target="_blank" rel="noreferrer">
                    imy.se
                  </a>
                  .
                </p>
              </Section>

              <Section title="Varifrån uppgifterna kommer">
                <p>
                  Kontouppgifter och inställningar lämnas av dig eller av den inloggningstjänst du
                  väljer. Tävlingsinformation kommer från offentliga resultatkällor, klubbar,
                  tävlingsadministration eller Lapstrs administratörer.
                </p>
              </Section>

              <Section title="Automatiserade beslut">
                <p>
                  Lapstr fattar inte automatiserade beslut som har rättsliga eller motsvarande
                  betydande konsekvenser för dig.
                </p>
              </Section>
            </TabsContent>

            <TabsContent value="terms" className="space-y-5">
              <Section title="Om tjänsten">
                <IntroNotice icon={Scale}>
                  <p>
                    Lapstr är en digital tjänst för speedway med fokus på matcher, matchkort,
                    matchprotokoll, notiser och relaterad information. Tjänsten tillhandahålls av
                    MV Kod &amp; Design AB.
                  </p>
                </IntroNotice>
              </Section>

              <Section title="Åldersgräns">
                <p>
                  Du måste ha fyllt 13 år för att skapa och använda ett eget konto. Innan tjänsten
                  tas i bruk behöver du bekräfta din ålder och uttryckligen acceptera den aktuella
                  versionen av användarvillkoren. Användare under 18 år får inte genom tjänsten
                  genomföra köp, ingå ekonomiska förpliktelser eller vidta andra rättshandlingar
                  som enligt tillämplig lag kräver vårdnadshavares godkännande, om ett sådant
                  godkännande saknas. Tjänsten riktar sig inte till barn under 13 år.
                </p>
              </Section>

              <Section title="Konto och ansvar">
                <ul className="list-disc space-y-1 pl-5">
                  <li>Du ansvarar för att dina inloggningsuppgifter hanteras säkert.</li>
                  <li>Du ansvarar för information som du själv registrerar i tjänsten.</li>
                  <li>Du får inte försöka kringgå säkerhet, störa tjänsten eller använda den otillåtet.</li>
                  <li>Du får inte använda tjänsten på ett sätt som kränker någon annans rättigheter eller bryter mot lag.</li>
                </ul>
              </Section>

              <Section title="Ditt innehåll">
                <p>
                  Du behåller rättigheterna till innehåll som du själv skapar. Du ger MV Kod &amp;
                  Design AB rätt att lagra, behandla och visa innehållet i den omfattning som krävs
                  för att tillhandahålla de funktioner du använder.
                </p>
              </Section>

              <Section title="Tillgänglighet och begränsningar">
                <p>
                  Vi strävar efter hög tillgänglighet men kan inte garantera att tjänsten alltid är
                  fri från fel, driftstörningar eller fördröjd data. Matchdata och annat innehåll kan
                  vara preliminärt eller bero av externa källor.
                </p>
              </Section>

              <Section title="Ändringar och kontoåtgärder">
                <p>
                  Funktioner kan läggas till, ändras eller tas bort när tjänsten utvecklas. Vi kan
                  tillfälligt begränsa delar av tjänsten för underhåll, felsökning eller säkerhet och
                  kan begränsa eller avsluta konton som används i strid med villkoren. Vid väsentliga
                  ändringar informerar vi i appen eller via en lämplig kontaktväg innan ändringen börjar gälla.
                </p>
              </Section>

              <Section title="Rättigheter och ansvar">
                <p>
                  Lapstrs design, varumärke, programvara och innehåll skyddas av tillämplig
                  immaterialrätt. Tvingande konsumenträtt gäller alltid. I övrigt ansvarar vi inte
                  för indirekta skador eller beslut som fattas enbart utifrån preliminär, fördröjd
                  eller felaktig matchinformation.
                </p>
              </Section>

              <Section title="Tillämplig lag och kontakt">
                <p>
                  Svensk lag tillämpas på villkoren. Frågor eller klagomål skickas till
                  support@lapstr.se. En konsument kan även vända sig till Allmänna
                  reklamationsnämnden eller behörig domstol när det är tillämpligt.
                </p>
              </Section>
            </TabsContent>

            <TabsContent value="notifications" className="space-y-5">
              <Section title="Hur pushnotiser fungerar">
                <IntroNotice icon={BellRing}>
                  <p>
                    Lapstr kan skicka pushnotiser om du tillåter det i din enhet eller webbläsare och
                    aktiverar notiser i appen.
                  </p>
                  <p>
                    Notiser kan användas för matchrelaterade uppdateringar, viktig information om
                    tjänsten och annan relevant information i appen.
                  </p>
                </IntroNotice>
              </Section>

              <Section title="Hur du stänger av notiser">
                <p>
                  Du kan när som helst stänga av notiser i appens inställningar eller i enhetens egna
                  inställningar för aviseringar. Om du återaktiverar notiser senare kan en ny
                  pushprenumeration behöva skapas på den aktuella enheten.
                </p>
              </Section>

              <Section title="Frivilliga e-postutskick">
                <p>
                  Nyheter och produktinformation via e-post är ett separat, frivilligt val. Det
                  påverkar inte nödvändiga konto-, säkerhets- eller verifieringsmeddelanden. Du kan
                  när som helst stänga av utskicken under Mina sidor och Data &amp; sekretess.
                </p>
              </Section>
            </TabsContent>

            <TabsContent value="cookies" className="space-y-5">
              <Section title="Cookies och annan lokal lagring">
                <IntroNotice icon={Cookie}>
                  <p>
                    Lapstr använder cookies, lokal lagring och motsvarande tekniker för att
                    tillhandahålla tjänsten, upprätthålla säkerhet och, efter samtycke, framställa
                    användningsstatistik och genomföra mätning.
                  </p>
                  <p>
                    I den detaljerade översikten anges vilka lagringstekniker som används, deras
                    ändamål och tillämpliga lagringstider.
                  </p>
                </IntroNotice>
              </Section>

              <Section title="Extern inloggningstjänst">
                <p>
                  Om du väljer att använda extern inloggning kan den aktuella leverantören behandla
                  uppgifter som krävs för autentisering. Sådan behandling omfattas även av
                  leverantörens egna villkor och integritetsinformation.
                </p>
              </Section>

              <Section title="Översikt över lagring som används i appen">
                <Accordion type="single" collapsible className="native-v3-legal-accordion rounded-xl border border-border/60 bg-background/60 px-4">
                  <AccordionItem value="storage-table" className="native-v3-legal-accordion-item border-b-0">
                    <AccordionTrigger className="native-v3-legal-accordion-trigger py-3 text-sm font-medium text-foreground hover:no-underline">
                      Visa detaljerad översikt över cookies och lokal lagring
                    </AccordionTrigger>
                    <AccordionContent className="native-v3-legal-accordion-content pt-1">
                      <StorageTable />
                    </AccordionContent>
                  </AccordionItem>
                </Accordion>
              </Section>

              <Section title="Nödvändig och valfri lagring">
                <p>
                  Lagring som är nödvändig för att tillhandahålla en uttryckligen begärd funktion,
                  exempelvis inloggning, kontosäkerhet och sessionshantering, används utan särskilt
                  samtycke. Lagring och behandling för användningsstatistik eller andra valfria
                  ändamål sker endast efter samtycke. Ett lämnat samtycke kan när som helst
                  återkallas genom integritetsinställningarna.
                </p>
                <div className="pt-1">
                  <Button
                    type="button"
                    variant="outline"
                    className="native-v3-legal-cookie-button"
                    onClick={() => {
                      clearCookieConsent();
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                  >
                    {consent ? "Ändra integritetsval" : "Visa integritetsval igen"}
                  </Button>
                </div>
              </Section>
            </TabsContent>

            <TabsContent value="contact" className="space-y-5">
              <Section title="Support och kontakt">
                <IntroNotice icon={Mail}>
                  <p>
                    För support, integritetsfrågor, feedback eller buggrapporter kontaktar du oss på{" "}
                    <a className="text-primary underline-offset-4 hover:underline" href="mailto:support@lapstr.se">
                      support@lapstr.se
                    </a>
                    .
                  </p>
                  <p>
                    Personuppgiftsansvarig och avtalspart är MV Kod &amp; Design AB,
                    organisationsnummer 559567-7039, Albert Tengers väg 39 A,
                    593 35 Västervik.
                  </p>
                </IntroNotice>
              </Section>
            </TabsContent>
          </Tabs>
        </CardContent>
      </Card>

      {!native ? <div className="fixed inset-x-0 bottom-[max(env(safe-area-inset-bottom),0.75rem)] z-20 flex justify-center px-4">
        <Button
          type="button"
          variant="outline"
          className="min-w-[220px] rounded-full bg-background/95 shadow-lg backdrop-blur"
          onClick={() => navigate(-1)}
        >
          <ArrowLeft className="mr-2 h-4 w-4" />
          Tillbaka
        </Button>
      </div> : null}
    </div>
  );
}
